import { useSyncExternalStore } from "react";

/**
 * The "scope corners" switch (localStorage `scope_enabled`, flipped through
 * the `scope-toggle` window event by the appearance settings) as ONE shared
 * subscription. It used to be a useState + useEffect + two window listeners
 * inside EVERY Button and ScopeWrapper — a creators-table page mounts
 * hundreds of buttons, so that was hundreds of listeners and effects per
 * page just to read one flag.
 */

const STORAGE_KEY = "scope_enabled";

function readEnabled(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) !== "disabled";
  } catch {
    return true;
  }
}

const listeners = new Set<() => void>();
let enabled = readEnabled();
let wired = false;

function wire() {
  if (wired || typeof window === "undefined") return;
  wired = true;
  const update = () => {
    const next = readEnabled();
    if (next === enabled) return;
    enabled = next;
    listeners.forEach((listener) => listener());
  };
  window.addEventListener("scope-toggle", update);
  window.addEventListener("storage", update);
}

function subscribe(listener: () => void) {
  wire();
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function getSnapshot() {
  return enabled;
}

function getServerSnapshot() {
  return true;
}

/** True while scope corners are on (the default). */
export function useScopeEnabled(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
